const perfionPictureSizes = {
  FIFTY: "50x50",
  ONEHUNDRED: "100x100",
  ONEFIFTY: "150x150",
  TWOHUNDRED: "200x200",
  THREEHUNDRED: "300x300",
  FOURHUNDRED: "400x400",
  FIVEHUNDRED: "500x500",
  EIGHTHUNDRED: "800x800",
  ORIGINAL: "original",
};

module.exports = {
  perfionPictureSizes,
};
